export default __webpack_public_path__ + "static/media/premium.faa8d77f.svg";